import {
  achievementEventDirectCampaignConditions,
  directCustomerConditions,
  eventDirectCampaignConditions,
  transactionDirectCampaignConditions,
} from "components/Layout/Campaign/Common/CampaignRules/rules";
import { CampaignTriggers, CampaignTriggersUnion } from "types/campaigns";
export const defaultRule = {};

export const getTriggerConditions = (
  trigger: CampaignTriggersUnion,
  event?: string,
) => {
  switch (trigger) {
    case CampaignTriggers.TRANSACTION:
    case CampaignTriggers.RETURN_TRANSACTION:
      return transactionDirectCampaignConditions;
    case CampaignTriggers.INTERNAL_EVENT:
      return event === "MemberAchievementProgressWasChanged"
        ? achievementEventDirectCampaignConditions
        : eventDirectCampaignConditions;
    case CampaignTriggers.CUSTOM_EVENT:
      return eventDirectCampaignConditions;
    case CampaignTriggers.CUSTOM_EVENT_UNIQUE_CODE:
      return eventDirectCampaignConditions;
    case CampaignTriggers.ACHIEVEMENT:
      return directCustomerConditions;
    default:
      return [];
  }
};
